import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import type { CARD_TYPE } from 'modules/expenses/lib/types'

export interface ISubscription {
  id: number
  custom_physical_card_creation_limit: number
  custom_forex_fees_discount_rate: number
  custom_virtual_card_creation_limit: number
  custom_single_use_card_creation_limit: number
  custom_approval_policy_creation_limit: number
  can_create_physical_cards: boolean
  can_create_virtual_cards: boolean
  can_create_single_use_cards: boolean
  plan_name: 'free' | 'basic' | 'pro' | 'unlimited'
  is_current: boolean
  created_at: string
  updated_at: string
}

class Subscription extends Model<ISubscription> {
  constructor(attr: ISubscription) {
    super(attr)
    makeObservable(this, {
      isCurrent: computed,
    })
  }

  static urlRoot() {
    return '/expenses/subscriptions'
  }

  get isCurrent(): boolean {
    return !!this.attributes.is_current
  }

  canCreateCard(cardType: CARD_TYPE): boolean {
    if (cardType === 'physical') {
      return this.attributes.can_create_physical_cards
    }

    if (cardType === 'single_use') {
      return this.attributes.can_create_single_use_cards
    }

    return this.attributes.can_create_virtual_cards
  }
}

export default Subscription
